// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"250":"87642af9e9c311e400fe","524":"34801177a56bb7cf06e4"}[chunkId] + ".css";
};